import React from 'react';
import { motion } from 'framer-motion';

const CodeBlockAnimation = () => {
  // Sample code snippets
  const codeSnippets = [
    "function init() {",
    "  return {",
    "    data: [],",
    "    loading: false,",
    "    error: null",
    "  };",
    "}",
    "",
    "const fetchData = async () => {",
    "  try {",
    "    const response = await api.get('/data');",
    "    return response.data;",
    "  } catch (error) {",
    "    console.error(error);",
    "    throw new Error('Failed to fetch data');",
    "  }",
    "};",
    "",
    "export default function App() {",
    "  const [state, setState] = useState(init());",
    "  useEffect(() => {",
    "    // Load data on mount",
    "    fetchData()",
    "      .then(data => setState({ ...state, data }))",
    "      .catch(error => setState({ ...state, error }));",
    "  }, []);",
    "}"
  ];

  return (
    <div className="absolute inset-0 overflow-hidden">
      <div className="absolute inset-0 bg-gray-900 opacity-90"></div>
      
      {/* Code blocks */}
      <div className="absolute inset-0 overflow-hidden text-xs font-mono">
        {codeSnippets.map((line, index) => (
          <motion.div
            key={index}
            className="text-blue-400 opacity-40 whitespace-pre px-4"
            initial={{ x: 100, opacity: 0 }}
            animate={{ 
              x: 0, 
              opacity: line ? 0.4 : 0.1 
            }}
            transition={{ 
              duration: 0.5,
              delay: index * 0.1,
              repeat: Infinity,
              repeatType: "reverse",
              repeatDelay: 20
            }}
          >
            {line || " "}
          </motion.div>
        ))}
      </div>
      
      {/* Animated cursor */}
      <motion.div 
        className="absolute w-2 h-4 bg-primary"
        initial={{ opacity: 0 }}
        animate={{ 
          opacity: [1, 0],
          top: ["10%", "85%"]
        }}
        transition={{ 
          opacity: {
            duration: 0.8,
            repeat: Infinity,
            repeatType: "reverse"
          },
          top: {
            duration: 15,
            repeat: Infinity,
            repeatType: "reverse",
            ease: "easeInOut"
          }
        }}
        style={{ left: "calc(5% + 8px)" }}
      />
    </div>
  );
};

export default CodeBlockAnimation;
